import { render, staticRenderFns } from "./AddictiveStuffClientForm.vue?vue&type=template&id=2afe1f20&scoped=true&"
import script from "./AddictiveStuffClientForm.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffClientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe1f20",
  null
  
)

export default component.exports